import baseApi from 'api/baseApi';
import { INamedEntity } from 'common/interfaces/common';
import { IRequestOptions } from 'common/interfaces/dictionary';
import { IPaginatedData } from 'common/interfaces/pagination';
import { IEmployeeBasicInfo } from 'interfaces/employee.interfaces';

const dictionaryApi = baseApi.injectEndpoints({
  endpoints: builder => ({
    getMemberPortalSalespersons: builder.query<
      IPaginatedData<IEmployeeBasicInfo>,
      IRequestOptions | void
    >({
      query: (options?: IRequestOptions) => ({
        url: '/api/v1/member-portal/profile/dictionary/salespersons',
        method: 'GET',
        params: options,
      }),
    }),

    getMemberPortalClubs: builder.query<
      IPaginatedData<INamedEntity<number>>,
      IRequestOptions | void
    >({
      query: (options?: IRequestOptions) => ({
        url: '/api/v1/member-portal/profile/club/dictionary',
        method: 'GET',
        params: options,
      }),
    }),
  }),
});

export const {
  useLazyGetMemberPortalSalespersonsQuery: useLazyGetMemberPortalSalespersons,
  useGetMemberPortalClubsQuery: useGetMemberPortalClubs,
} = dictionaryApi;

export default dictionaryApi;
